export default __webpack_public_path__ + "static/media/gl.1620115c.jpg";